import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '@src/environments/environment';
import { formatDateTimeInLocalTimeZone, parseDate } from '@/src/app/utils/date.utils';
import { ValueSeparatorComponent } from '../../modules/general-commons/components/value-separator/value-separator.component';

@Component({
  selector: 'stx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, ValueSeparatorComponent, TranslateModule, GeneralCommonsModule]
})
export class FooterComponent {
  envVersion: string;
  buildTimestamp: string;

  constructor() {
    this.envVersion = environment.version;
    this.buildTimestamp = formatDateTimeInLocalTimeZone(parseDate(environment.buildTimestamp));
  }
}

@NgModule({
  exports: [FooterComponent],
  imports: [CommonModule, MatIconModule, GeneralCommonsModule, TranslateModule, FooterComponent]
})
export class FooterComponentModule {}
